<template>
  <div class="app" >
   
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/home">
        <img class="navbar-brand-full" src="@/assets/img/brand/logo.png" width="104" height="46" alt="Logo Paraná">
        <img class="navbar-brand-minimized" src="@/assets/img/brand/brasao.png" width="30" height="30" alt="Logo Paraná">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <ul class="identificacao">        
       <li class="nome-cliente">Procuradoria Geral do Estado</li>
       <li class="nome-sistema">PROAJU</li>
      </ul>
  
      <b-navbar-nav class="ml-auto">
          <ContaUsuario/>
      </b-navbar-nav>
    </AppHeader>

    <div class="app-body" >
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        
        <SidebarNav :navItems="nav" style="font-size:12px; font-weight: bold;"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <Messages />
          <router-view></router-view>
        </div>
      </main>
    </div>
    
    <TheFooter>
      <div> <span class="ml-1">Desenvolvido pela </span>
        <a href="http://www.celepar.pr.gov.br/" target="_blank"><img src="https://www.pr.gov.br/logos/celepar/logo-celepar.png"/></a>
        <small>&nbsp; - v0_0_177H - 17/09/2024 10:00h</small>
      </div>
      <div class="ml-auto">
        <router-link to="/info"> Informações Legais </router-link>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import menu from '@/api/menu'
import { 
  Header as AppHeader, 
   SidebarToggler, 
   Sidebar as AppSidebar, 
   SidebarFooter, 
   SidebarForm, 
   SidebarHeader, 
   SidebarMinimizer, 
   SidebarNav,
   Footer as TheFooter, 
   Breadcrumb} from '@coreui/vue';
import Messages from '@/views/shared/components/Messages';
import ContaUsuario from '@/views/layout/ContaUsuario';

export default {
  name: 'Admin',
  components: {
    AppHeader,
    AppSidebar,
    TheFooter,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    Messages,
    ContaUsuario
  },
  data () {
    return {
      nav: []
    }
  },
  computed: {
    name () {
      return this.$route.name;
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label);
    }
  },
    methods: {
        adicionarChildren(el, userData) {
            if (el.children !== undefined && el.children.length > 0) {
                let childrenTemp = [];
                el.children.forEach(ch => {
                    if (userData.token.groups) {
                        let permissionCh = false,
                            groupNameCh = '';
                        for (let i = 0; i < userData.token.groups.length; i++) {
                            groupNameCh = userData.token.groups[i].nome;
                            if (ch.groups.indexOf(groupNameCh) != -1) {
                                permissionCh = true;
                                break;
                            }
                        }

                        if (permissionCh) {
                            this.adicionarChildren(ch, userData);
                            childrenTemp.push(ch);
                        }
                    }
                });

                el.children = childrenTemp;
            }
        }
    },
  mounted() {
    let temp = [];

      menu.items.forEach(el => {
          let userData = JSON.parse(this.$store.getters.getUser);
          if (userData.token.groups) {
              let permission = false,
                  groupName = '';
              for (let i = 0; i < userData.token.groups.length; i++) {
                  groupName = userData.token.groups[i].nome;
                  if (el.groups.indexOf(groupName) != -1) {
                      permission = true;
                      break;
                  }
              }

              if (permission) {
                  this.adicionarChildren(el, userData);

                  temp.push(el);
              }
          }
      });

    this.nav = temp;
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import '../../assets/scss/style';

</style>

